export default __webpack_public_path__ + "static/media/banner-image-square-3.fc6e99de.jpg";